import React from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import type { Location } from 'history'
import HeadData from 'components/Common/HeadData'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import ContactUsForm from './ContactUsForm'
import LegalPages from 'components/Pages/LegalPages'
import config from 'constants/config'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  phone: App.GeoContacts
  location: Location<any>
  slug: string
}

function NewsPage(props: Props) {
  const intl = useIntl()
  const { phone, location, slug } = props
  const contactPhone = phone[phone.default].humanReadable || '+61 2 8320 6845'
  const callUs = intl.formatMessage(
    {
      id: 'CkwtXfE73b',
      defaultMessage: 'You can call our friendly customer support team on {contactPhone}',
      description: 'Call to action text with support phone number on the news page',
    },
    { contactPhone },
  )

  // There are inconsistencies in Contentful slug-naming schemes
  // ...so that this one luxuryescapes item needs "luxuryescapes-" prefix in the slug
  // Other brands slug-name brand prefixes are handled in the LegalPages component
  const brandedSlug = config.BRAND === 'luxuryescapes' ?
    `${config.BRAND}-${slug}-content-page` :
    `${slug}-content-page`

  return <>
    <HeadData
      title={intl.formatMessage({
        id: '275sc9PmVg',
        defaultMessage: 'Latest News',
        description: 'Page title for the latest news page',
      })}
      description={intl.formatMessage(
        {
          id: 'zV9gFPbKSK',
          defaultMessage: 'Latest News about {siteTitle}',
          description: 'Meta description for the latest news page',
        },
        { siteTitle: config.title },
      )}
    />
    <Pane background="neutral-six">
      <PaneBody size="lg">
        <LayoutContainer>
          <VerticalSpacer gap={56}>
            <LegalPages slug={brandedSlug} location={location} />
            {config.contactForm && <ContactUsForm />}
            <BodyText variant="large" weight="bold" as="h3">{callUs}</BodyText>
          </VerticalSpacer>
        </LayoutContainer>
      </PaneBody>
    </Pane>
  </>
}

const mapStateToProps = (state: App.State) => ({
  phone: state.geo.currentContact,
})

export default connect(mapStateToProps)(NewsPage)
